import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import * as authAPI from 'services/api-auth';
import { AuthWrapper } from 'components/containers';
import { ExpTextField } from 'components/elements';
import useLoading from 'hooks/useLoading';
import { showErrorToast, showSuccessToast } from 'utils/helpers/toast';
import { EMAIL_VALID, LINKS } from 'utils/constants';
import { Button, makeStyles } from '@material-ui/core';

const schema = yup.object().shape({
  email: EMAIL_VALID,
});

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginBottom: theme.spacing(4),
    width: '100%',
  },
  button: {
    marginBottom: theme.spacing(2.5),
    borderRadius: theme.spacing(3),
    height: 50,
  },
}));

const ForgotPassword = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { changeLoadingStatus } = useLoading();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = useCallback(
    async (data) => {
      changeLoadingStatus(true);
      try {
        const params = {
          email: data.email,
        };

        const { message } = await authAPI.forgotPassword(params);
        showSuccessToast(message);
        navigate(LINKS.resetPassword.path, { query: { email: data.email } });
      } catch (error) {
        showErrorToast(
          'Your email does not existed. Please input correct email.'
        );
      }
      changeLoadingStatus(false);
    },
    [navigate, changeLoadingStatus]
  );

  return (
    <AuthWrapper title="Reset Password">
      <form
        noValidate
        className={classes.form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Controller
          as={<ExpTextField />}
          name="email"
          type="email"
          label="E-mail"
          error={errors.email?.message}
          className={classes.input}
          control={control}
          defaultValue=""
        />
        <Button
          type="submit"
          color="primary"
          variant="contained"
          fullWidth
          className={classes.button}
        >
          Submit
        </Button>
        <Button
          color="secondary"
          variant="contained"
          fullWidth
          className={classes.button}
          href={LINKS.signIn.path}
        >
          Cancel
        </Button>
      </form>
    </AuthWrapper>
  );
};

export default memo(ForgotPassword);
